import { flowRight } from 'lodash/fp';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { pure } from 'recompose';
import { POST } from 'utils/httpMethods';
import { Action, Actions, Date, Initials, Item, connectActiveItem } from '../list';
import capitelizeFirstLetter from '../../utils/capitelizeFirstLetter';
import { setModal } from '../../actions';
import WarningModal from './warningModal';

const ListItemManagementAct = ({ rip, item, isActive, show, open }) => {
    const navigate = useNavigate();

    const handleOpen = () => {
        open(navigate);
    };

    const redirectMessage = (compagnyChoice) => `Accéder au portail ${capitelizeFirstLetter(compagnyChoice)}`;

    const contractStateProduct = (state, compagnyChoice) => {
        if ('completedDigital' === state) {
            return <div>Pris en charge sur {capitelizeFirstLetter(compagnyChoice)}</div>;
        }

        return <div />;
    };

    const redirectToHub = async () => {
        try {
            const response = await POST(`/api/contracts/managementAct/${item.id}/url`);
            const { url } = await response.json();
            window.open(url, '_blank');
        } catch (error) {
            console.error('error get managementAct/url => ', error);
        }
    };

    if ('completedDigital' !== item.state) {
        return null;
    }

    return (
        <Item
            displayActions={isActive}
            onFocus={!isActive ? () => show() : null}
        >
            <Initials firstName={rip.firstName} lastName={rip.lastName} />
            <td>{capitelizeFirstLetter(item.operationType)}</td>
            <td>{capitelizeFirstLetter(item.compagnyChoice)}</td>
            <td>{item.managementActContractRefAct}</td>
            <Date date={item.createdAt} />
            <Date date={item.updatedAt} />
            <td>{contractStateProduct(item.state, item.compagnyChoice)}</td>

            <Actions>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '130px' }}>
                    <Action onClick={redirectToHub} icon="desktop" text={redirectMessage(item.compagnyChoice)} />
                    <Action onClick={handleOpen} icon="return" text="renvoyer" />
                </div>
            </Actions>
        </Item>
    );
};

ListItemManagementAct.propTypes = {
    rip: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        id: PropTypes.string,
    }).isRequired,
    item: PropTypes.shape({
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
        state: PropTypes.string,
        id: PropTypes.string,
        operationType: PropTypes.string,
        compagnyChoice: PropTypes.string,
        managementActContractRefAct: PropTypes.string,
    }).isRequired,
    isActive: PropTypes.bool.isRequired,
    show: PropTypes.func.isRequired,
    open: PropTypes.func,
};

export default flowRight([
    connectActiveItem(
        ({ item: { id } }) => id,
        (item, { activeItem }) => ({ isActive: item === activeItem }),
    ),
    connect(null, (dispatch, { rip, item }) => ({
        open: (navigate) => {
            const handleConfirm = () => {
                dispatch(setModal(null));

                return navigate(`/rip/${rip.id}/contracts/${item.id}/managementActHub/${item.compagnyChoice}`);
            };

            dispatch(setModal(() => (
                <WarningModal
                    title="Attention"
                    message={
                        <Fragment>
                            Cette opération est uniquement prévue pour les actes de gestion en erreur sur l&apos;eRIP.
                            <br />
                            Si vous validez, l&apos;ancienne opération sera remplacée par celle-ci.
                        </Fragment>
                    }
                    close={() => dispatch(setModal(null))}
                    onConfirm={handleConfirm}
                />
            ), true));
        },
    })),
    pure,
])(ListItemManagementAct);
